import { useRef, useState, useCallback } from 'react'

/**
 * A custom hook that returns a ref and a setter function.
 * Updating the ref also triggers a re-renderable signal via state,
 * allows you to track ref changes in `useEffect`.
 */
const useWatchedRef = <T,>(initialValue?: T) => {
  const ref = useRef<T | undefined>(initialValue)
  const [, setVersion] = useState(0)

  const set = useCallback((newValue: T) => {
    ref.current = newValue
    setVersion((v) => v + 1)
  }, [])

  return [ref, set] as const
}

export default useWatchedRef
